import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Styled } from './styles';
import type { CardProps } from './types';

export type { CardProps } from './types';
type DivProps = Omit<ComponentPropsWithoutRef<'div'>, keyof CardProps>;

type Props = DivProps & CardProps;

export const Card = forwardRef<HTMLDivElement, Props>(({ px = 'm', py = 'm', ...props }, ref) => (
  <Styled.Container {...props} px={px} py={py} ref={ref} />
));
Card.displayName = 'Card';
